import React from 'react';
import PropTypes from 'prop-types';
import './ButtonSwitcher.css';

function ButtonSwitcher(props) {
  const { buttonsList, buttonWidth } = props;
  
  return(
    <div className="button-switcher__component">
      {buttonsList.map((item) => (
        <div 
          key={item.buttonName}
          className={`btn${item.checked ? ' active' : ''}`}
          onClick={item.executeFunc}
          role="button"
          tabIndex={-1}
          style={buttonWidth && {
            width: `${buttonWidth}px`,
          }}
        >
          {item.buttonIcon &&
            <div className={`icon ${item.buttonIcon}`} />
          }
          {item.buttonName}
        </div>
      ))}
    </div>
  );
};

ButtonSwitcher.propTypes = {
  buttonsList: PropTypes.array.isRequired,
  buttonWidth: PropTypes.number,
};

ButtonSwitcher.defaultProps = {
  buttonWidth: null,
};

export default ButtonSwitcher;
